export default __webpack_public_path__ + "static/media/template_logo.bed4e5a2.svg";